var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

const React = require('react');
const Icon = require('@infotech/uikit-icon').default;

function Svg(props) {
  const svgProps = Object.assign({}, props);
  const title = props.title;
  delete props.title;

  /* <svg {...svgProps} ><title>{title}<title>...</svg> */
  return React.createElement(
    'svg',
    _extends({ width: '23', height: '23', viewBox: '0 0 23 23', focusable: 'false' }, svgProps, { 'aria-labelledby': 'title' }),
    React.createElement(
      'title',
      { id: 'title' },
      title
    ),
    React.createElement('path', { d: 'M12.386 1.073L22.435 11.12a1 1 0 010 1.415l-9.9 9.899a1 1 0 01-1.414 0L1.073 12.386a1 1 0 01-.292-.753l.442-9.458a1 1 0 01.952-.952L11.633.78a1 1 0 01.753.292zM3.178 3.178L2.8 11.285l9.03 9.029 8.485-8.486-9.03-9.029-8.106.38zM8.293 10a1.707 1.707 0 110-3.414 1.707 1.707 0 010 3.414z', fillRule: 'evenodd', role: 'presentation' })
  );
}

module.exports = function group(props) {
  return React.createElement(Icon, _extends({ glyph: Svg }, props));
};